module.exports = __webpack_public_path__ + "vue-tags-input/assets/fonts/icomoon-fb4f0598ef76886424fb9ab305eba118.woff";